/// <reference path="./Box/Pane.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class Page extends Container {

        public static createNewByType(data: Map<any, any>, main: Tag) {
            return (new Page()).createByType(data, main);
        }

        protected createByType(data: Map<any, any>, main: Tag) {
            const t = data.get("t");
            let tag: Tag = null;
            switch (t) {
                case "m":
                    main.appendChild(new Div(data));
                    return;
                case "pa-a":
                    tag = new ArticlePage(data);
                    break;
                case "pa-s":
                    tag = new Page(data);
                    break;
                case "pa-m":
                    tag = new ResultListPage(data);
                    break;
                case "pa-rlp":
                    tag = new ResultListPage(data);
                    break;
                case "s":
                    tag = new HA.Core.HTML.TBox.Section({d: data.get("d")});
                    break;
                case "tb":
                    tag = new TextBox({tdata: data.get("d")});
                    break;
                default :
                    super.createByType(data, main);
                    break;
            }

            if (tag) {
                main.appendChild(tag);
            }
        }

        protected initialize(data: any) {
            super.initialize(data);
            this.addAttribute("tt", "pa");
            this.addClass("pages");
        }
        protected createSelf() {
            super.createSelf();
            const c = new CFlexContainer({class: "pa-cont"});
            const me = this;
            const tdata = this.get("d");
            const trans = this.get("trans");
            if (tdata) {
                try {
                    this.replaceValues(tdata);
                    tdata.forEach((item: any) => {
                        if (!item) {
                            return;
                        }
                        const nitem = toMap(item);
                        if (trans) {
                            nitem.set("trans", trans);
                        }
                        me.createByType(nitem, c);
                    });
                } catch (e) {
                    throw e;
                }
            }

            this.appendChild(c);
        }
    }
}
